import styled from 'styled-components';
import { Box } from '../Box';

export const NavigationItemContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NavigationButtonContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const NavigationTextContainer = styled(Box)`
  flex-grow: 1;
  min-width: 0; /* Allow flex item to shrink below content size */
  overflow: hidden; /* Prevent overflow */
`;

export const VisibilityContainer = styled(Box)<{ $isVisible: boolean }>`
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
`;
